import { Button, Input, Stack, Text } from '@chakra-ui/react'

interface Props {
  adminFiles: FileList | null
  setAdminFiles: (files: FileList | null) => void
  uploading: boolean
  onUpload: () => Promise<void>
}

export function DiagnosisUploadForm({
  adminFiles,
  setAdminFiles,
  uploading,
  onUpload,
}: Props) {
  return (
    <Stack
      spacing={2}
      border='1px dashed'
      borderColor='gray.300'
      p={3}
      rounded='md'
      w='30%'
    >
      <Text fontWeight='semibold' fontSize='sm'>
        Add Diagnosis Documentation
      </Text>
      <Input
        type='file'
        multiple
        accept='.pdf,.jpg,.jpeg,.png'
        onChange={(e) => setAdminFiles(e.target.files)}
      />
      <Button
        size='sm'
        onClick={onUpload}
        isLoading={uploading}
        disabled={!adminFiles?.length}
      >
        Upload
      </Button>
      <Text fontSize='xs' color='gray.500'>
        Accepted: PDF / JPG / PNG
      </Text>
    </Stack>
  )
}
